import { i18n } from '@/commons/utils';


export const init = () => {
  const select = cube.$id('company-type');

  select.on('change', updateCompanyFields);
  select.on('change', isVatOrImatRequired);

  select.dispatchEvent(new CustomEvent('change'));
};




function isRequired (input) {
  return input.closest('div').$('label').innerText.includes('*');
};



/**
 * In some case, for some company types
 * VAT or IMAT field is required (at least one of the two)
 */
function isVatOrImatRequired () {
  const selectedType = this.value;
  const vatOrImatCheckPresence = cube.$id('vatOrImatCheckPresence');
  const companyTypeMap = cube.$id('companyTypeMap');

  if (!vatOrImatCheckPresence || !companyTypeMap) return;

  let vatOrImatIsRequired = false;

  if (selectedType && vatOrImatCheckPresence && companyTypeMap) {
    const vatOrImatCheckPresenceValue = JSON.parse(vatOrImatCheckPresence.value);
    const companyTypeMapValue = JSON.parse(companyTypeMap.value);
    const choice = Object.entries(companyTypeMapValue).find(entry => entry.includes(selectedType))[0];

    vatOrImatIsRequired = vatOrImatCheckPresenceValue.includes(choice);
  }

  const vatNumber = cube.$id('vatNumber');
  const registerNumber = cube.$id('registerNumber');

  [vatNumber, registerNumber].forEach(field => {
    if (!field) return;

    // Remove previous error
    if(field.closest('.form-group') && field.closest('.form-group').classList.contains('has-error')) {
      field.value = '';
      field.closest('.form-group').classList.remove('has-error');
      field.closest('.form-group').querySelector('.form-help .text').innerHTML = '';
    }

    // If company selected is one of vatOrImatCheckPresenceValue array
    // At least one of the two inputs are required
    // And input can not be blank ! (required rule manage that but not require_from_group !)
    if (vatOrImatIsRequired) {
      field.classList.add('vatOrImatIsRequired');
      $(field).rules('remove', 'required');
      $(field).rules('add', {'require_from_group': [1, '.vatOrImatIsRequired']});
      $(field).rules('add', {'not_blank': true});
    }

    // If not, we reset the default input rules
    else {
      field.classList.remove('vatOrImatIsRequired');
      $(field).rules('remove', 'required');
      if (isRequired(field))
        $(field).rules('add', {'required': true});
      $(field).rules('remove', 'require_from_group');
      $(field).rules('remove', 'not_blank');
    }
  });
};


/**
 * Update company fields depending on configuration.
 *
 */
function updateCompanyFields () {
  const selectedType = this.value;
  const textMandatoryField = i18n('fields.mandatory');
  const textOptionalField = i18n('fields.notMandatory');
  const types = {};
  const imatMap = cube.$id('btobImatMap');
  const tvaMap = cube.$id('btobTvaMap');
  const serviceMap = cube.$id('btobServiceMap');

  if (imatMap)
    types.imat = {
      map: JSON.parse(imatMap.value),
      label: cube.$id('rcsLbl'),
      field: cube.$id('registerNumber'),
      sub: cube.$id('company-rcs-sub-block')
    };

  if (tvaMap)
    types.tva = {
      map: JSON.parse(tvaMap.value),
      label: cube.$id('tvaLbl'),
      field: cube.$id('vatNumber'),
      sub: cube.$id('company-tax-sub-block')
    };

  if (serviceMap)
    types.service = {
      map: JSON.parse(serviceMap.value),
      label: cube.$id('serviceLbl'),
      field: cube.$id('service'),
      sub: cube.$id('company-service-sub-block')
    };

  Object.keys(types).forEach(type => {
    const { map, label, field, sub } = types[type];

    switch (map[selectedType]) {
      // Don't show //
      case 'D': {
        sub.classList.add('hidden');
        break;
      }

      // Mandatory //
      case 'M': {
        sub.classList.remove('hidden');
        field.required = true;

        if (!label.textContent.includes(textMandatoryField))
          label.textContent = label.textContent.replace(textOptionalField, textMandatoryField);

        break;
      }

      // Optional //
      case 'O': {
        sub.classList.remove('hidden');
        field.required = false;
        label.textContent = label.textContent.replace(textMandatoryField, textOptionalField);

        break;
      }

      default: {
        sub.classList.add('hidden');
        field.value = '';
        sub.classList.remove('validated');
        sub.classList.remove('has-error');
      }
    }

    const vatMap = JSON.parse(cube.$('#vatMap').value);
    const vatNumber = cube.$('#vatNumber');
    switch (selectedType) {
      case '27': {
        vatNumber.setAttribute('pattern', vatMap.school.pattern);
        break;
      }

      case '5': {
        vatNumber.setAttribute('pattern', vatMap.administration.pattern);
        break;
      }

      case '21': {
        vatNumber.setAttribute('pattern', vatMap.association.pattern);
        break;
      }

      case '6': {
        vatNumber.setAttribute('pattern', vatMap.company.pattern);
        break;
      }

      case '2': {
        vatNumber.setAttribute('pattern', vatMap.sportClub.pattern);
        break;
      }

      case '22': {
        vatNumber.setAttribute('pattern', vatMap.other.pattern);
        break;
      }

      default: {
        break;
      }
    }
  });

}


export const rules = {
  rules: {
    companyName: {
      maxlength: 255,
      extendedalphanumeric: true
    },
    registerNumber: {
      maxlength: 255,
      extendedalphanumeric: true
    },
    vatNumber: {
      maxlength: 255,
      extendedalphanumeric: true
    }
  },

  messages: {
    registerNumber: {
      require_from_group: i18n('create_account.formGroupRequired'),
    },
    vatNumber: {
      require_from_group: i18n('create_account.formGroupRequired'),
    }
  }
};



// WEBPACK FOOTER //
// ./src/customer/customer-company-type.js